export default function () {
  $('.gallery-mobile').each(function(){
    const $el = $(this)
  
    $el.find('.lightbox-init').lightGallery({
      thumbnail: true,
      selector: '.non-clickable',
      autoplay: false,
      autoplayControls: false,
      fullScreen: false,
      zoom: false,
      download: false,
      hash: false
    })
  
    $(document).on('slide-click', function(e, slideIndex) {
      $el.find(`.non-clickable[data-index="${slideIndex}"]`).trigger('click')
    })
  
    $el.on('onBeforeOpen.lg', function() {
      $('.zsiq_float').css('visibility', 'hidden')
    })
    $el.on('onCloseAfter.lg', function() {
      $('.zsiq_float').css('visibility', '')
    })

    const photos = $(this).find('.gallery-mobile-photo')

    photos.each(function() {
      const intrinsicWidth = $(this).attr('data-intrinsic-width')
      const intrinsicHeight = $(this).attr('data-intrinsic-height')

      if (intrinsicWidth && intrinsicHeight) {
        const currentWidth = $(this).width()
        const scaleRatio = currentWidth / intrinsicWidth // 817 / 2000
        const expectedHeight = scaleRatio * intrinsicHeight

        $(this).css('height', `${expectedHeight}px`)
      }
    })
  })
}
